import moment from 'moment';
import Config from 'services/config/local';
import Utils from 'services/utils';
import Thing from './thing.class';
import ThingUpdatesSubscription from './thing-subscriber.class';

export default class ThingsApi {
    /** @ngInject */
    constructor($http, ThingsService, AuthService) {
        this.$http = $http;
        this.config = Config.api.things;
        this.ThingsService = ThingsService;
        this.AuthService = AuthService;
        this.listUrl = Utils.buildApiUrl('things.list');
    }

    mapToThing(item) {
        const thing = new Thing(item);
        thing.setTypeConfig(thing.type ? this.ThingsService.getThingByType(thing.type.id) : null);
        // TODO: remove this after Cloud-Connector time-drift issue resolved
        if (thing.state) {
            if (moment(thing.state.updated).isAfter()) {
                thing.state.updated = moment().format();
            }
        }
        return thing;
    }

    getList(options = {}) {
        const params = {};

        Object.keys(options)
            .filter(key => options[key])
            .forEach((key) => {
                params[key] = options[key];
            });

        return this.$http
            .get(this.listUrl, { params })
            .then(Utils.httpExtractData)
            .then((data) => {
                if (data.things) {
                    data.things = data.things.map(this.mapToThing.bind(this));
                }
                return data;
            });
    }

    entity(thingId) {
        const url = Utils.buildApiUrl('things.entity', { thingId });
        return this.$http
            .get(url)
            .then(Utils.httpExtractData)
            .then(thing => this.mapToThing(thing));
    }

    update(thingId, params) {
        const url = Utils.buildApiUrl('things.entity', { thingId });

        return this.$http
            .patch(url, params).then(Utils.httpExtractData);
    }

    getWatchUrl(thingIds) {
        const thingIdsUri = thingIds.map(id => `&thing_ids=${id}`).join('');
        const baseUrl = Utils.buildApiUrl('things.subscribe');
        return () => `${baseUrl}?token=${this.AuthService.getAccessToken()}${thingIdsUri}`;
    }

    subscribeToThingUpdates(thingId, onUpdateCallback) {
        return this.subscribeToAllUpdates([thingId], onUpdateCallback);
    }

    subscribeToAllUpdates(thingIds, onUpdateCallback) {
        return new ThingUpdatesSubscription(this.getWatchUrl(thingIds), onUpdateCallback);
    }

    historicalQuery(thingId, params) {
        const requestUrl = Utils.buildApiUrl('things.history', { thingId });
        return this.$http.post(requestUrl, params).then(Utils.httpExtractData);
    }

    historicalQueryAggregated(thingId, params) {
        const requestUrl = Utils.buildApiUrl('things.historyAggregated', { thingId });
        return this.$http.post(requestUrl, params).then(Utils.httpExtractData);
    }

    star(thingId) {
        const url = Utils.buildApiUrl('things.star', { thingId });

        return this.$http.post(url, {});
    }

    unstar(thingId) {
        const url = Utils.buildApiUrl('things.unstar', { thingId });

        return this.$http.post(url, {});
    }
}



// WEBPACK FOOTER //
// ./app/services/api/things/things.service.js